export const LANG_AR_NAME = 'ar';

export const LANG_AR_TRANS = {
    'hello': 'مرحبا',
};

export const LANG_AR_DIR = 1;
